import { Parent } from '@/models/Parent'
import { StudentRepository } from '@/repository/StudentRepository'
import { ParentRepository } from '@/repository/ParentRepository'
import { TeacherRepository, QueryCondition as teacherCondition } from '@/repository/TeacherRepository'
import { StudentHasRelationsError, StudentHasLessonsError } from '@/service/student/errors'

class StudentDeleter {
  constructor(client, user) {
    if(!(client)) {
      throw new TypeError(`'client' is required.`)
    }
    this.deleter = StudentDeleterFactory.create(client, user)
  }

  async execute(studentId) {
    if (!(typeof studentId === 'string')) {
      throw new TypeError(`'studentId' must be String. Actual: ${typeof studentId}`)
    }
    return await this.deleter.execute(studentId)
  }
}

class StudentDeleterFactory {
  static create(client, user) {
    if (user instanceof Parent) {
      return new ParentStudentDeleter(client, user)
    }  else {
      throw new TypeError(`'user' must be an instance of either [object Parent] or [object Teacher]. Actual: ${typeof user}`)
    }
  }
}

class ParentStudentDeleter {
  constructor(client, parent) {
    this.studentRepo = new StudentRepository(client)
    this.parentRepo = new ParentRepository(client)
    this.teacherRepo = new TeacherRepository(client)
    this.parent = parent
  }

  async execute(studentId) {
    this._canDelete(studentId)
    let teachers = await this._deleteFromTeachers(studentId)
    await this.studentRepo.delete(studentId)
    return await this._deleteFromParent(studentId)
  }

  async _deleteFromTeachers(studentId) {
    let teachers = await this._queryTeachers(studentId)
    return await teachers.asyncMap(async (teacher) => {
      return await this.teacherRepo.update(teacher.removeStudentId(studentId))
    })
  }

  async _queryTeachers(studentId) {
    const condition = teacherCondition.studentId
    return await this.teacherRepo.query(condition(studentId))
  }

  async _deleteFromParent(studentId) {
    this.parent.deleteStudent(studentId)
    return await this.parentRepo.update(this.parent)
  }

  _canDelete(studentId) {
    const student = this.parent.findStudent(studentId)
    if (!(student.getLessons().length() === 0)) {
      throw new StudentHasLessonsError(`まだ授業の予定があるため、登録を抹消できません。`)
    }
    if (!(student.getTeacherIds().length === 0)) {
      throw new StudentHasRelationsError(`先生の担当をすべて解除してください。`)
    }
  }
}

export { StudentDeleter }